// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color: #007bff;
    --secondary-color: #f8f9fa;
    --text-color: #333;
    --status-open: #007bff;
    --status-closed: #28a745;
    --status-not-delivered: #dc3545;
    --status-pending: #ffc107;
}

.csvdownliad-dispatcher-container {
    display: flex;
    height: 100vh;
    background-color: var(--secondary-color);
    overflow: hidden;
    z-index: 100;
}

  /* Боковая панель с маршрутами */
  .csvdownliad-sidebar {
    width: 350px;
    background: white;
    padding: 20px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.csvdownliad-1);
  }
  
  .csvdownliad-sidebar h2 {
    font-size: 20px;
    margin-bottom: 10px;
    text-align: center;
  }
  

/* Контейнер для маршрутов с прокруткой */
.csvdownliad-routes-list {
    flex-grow: 1;
    overflow-y: auto;
    padding: 0;
    margin-bottom: 10px;
}

.csvdownliad-routes-list::-webkit-scrollbar {
    width: 6px;
}

.csvdownliad-routes-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.csvdownliad-2);
    border-radius: 3px;
}

.csvdownliad-routes-list li {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    transition: background-color 0.csvdownliad-2s ease-in-out;
}

.csvdownliad-routes-list li:hover,
.csvdownliad-routes-list .csvdownliad-active {
    background-color: var(--primary-color);
    color: white;
}

/* Основная часть с деталями маршрута */
.csvdownliad-route-details {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
}

.csvdownliad-route-details h2 {
    font-size: 22px;
    margin-bottom: 10px;
}

/* Таблица квитанций */
.csvdownliad-receipts-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.csvdownliad-05);
}

.csvdownliad-receipts-table th,
.csvdownliad-receipts-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

.csvdownliad-receipts-table th {
    background-color: var(--primary-color);
    color: white;
    cursor: pointer;
    transition: background 0.csvdownliad-2s ease-in-out;
}

.csvdownliad-receipts-table th:hover {
    background: #0056b3;
}

/* Статусы */
.csvdownliad-status {
    font-weight: bold;
    padding: 5px;
    border-radius: 5px;
    color: white;
    display: inline-block;
    min-width: 100px;
}

.csvdownliad-status.csvdownliad-Открыта {
    background-color: blue;
}

.csvdownliad-status.csvdownliad-закрыта {
    background-color: green;
}

.csvdownliad-status.csvdownliad-не-доставлено {
    background-color: red;
}

.csvdownliad-status.csvdownliad-в-обработке {
    background-color: var(--status-pending);
    color: black;
}

/* Заглушка, если маршрут не выбран */
.csvdownliad-placeholder-text {
    font-size: 16px;
    color: #888;
    text-align: center;
    margin-top: 50px;
}

/* Настройки колонок */
.csvdownliad-sidebar label {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 5px;
}

.csvdownliad-sidebar label input {
    margin-right: 5px;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
    .csvdownliad-dispatcher-container {
        flex-direction: column;
        height: auto;
    }

    .csvdownliad-sidebar {
        width: 95%;
        box-shadow: none;
        padding: 10px;
        background: #fff;
    }

    .csvdownliad-routes-list {
        display: flex;
        overflow-x: auto;
        gap: 5px;
        white-space: nowrap;
        padding: 10px 0;
    }

    .csvdownliad-routes-list li {
        display: inline-block;
        padding: 10px;
        font-size: 14px;
        border-radius: 5px;
        background: #f1f1f1;
        cursor: pointer;
    }

    .csvdownliad-route-details {
        padding: 15px;
    }

    /* Адаптация таблицы под мобильные */
    .csvdownliad-receipts-table {
        display: block;
        width: 100%;
        overflow-x: auto;
    }

    .csvdownliad-receipts-table thead {
        display: none;
    }

    .csvdownliad-receipts-table tbody {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .csvdownliad-receipts-table tr {
        display: flex;
        flex-direction: column;
        padding: 10px;
        background: white;
        border: 1px solid #ddd;
        border-radius: 8px;
    }

    .csvdownliad-receipts-table td {
        border: none;
        text-align: left;
        padding: 5px 0;
    }

    .csvdownliad-receipts-table td:first-child {
        font-weight: bold;
    }
}

.csvdownliad-date-filter-row {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}

.csvdownliad-date-filter-row label {
  display: flex;
  align-items: center;
  gap: 4px;
}

.csvdownliad-date-filter-row input[type="date"] {
  padding: 2px 4px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}


/* Базовый стиль кнопок в блоке organization-downloads */
.organization-downloads button {
  color: #fff;
  border: none;
  padding: 10px 15px;
  margin: 5px 5px 5px 0;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Обычный CSV — синий */
.organization-downloads button.csv-btn {
  background-color: #007bff;
}

.organization-downloads button.csv-btn:hover {
  background-color: #0056b3;
  transform: scale(1.02);
}

.organization-downloads button.csv-btn:active {
  background-color: #004085;
  transform: scale(0.98);
}

/* Watermark CSV — зелёный */
.organization-downloads button.watermark-btn {
  background-color: #28a745;
}

.organization-downloads button.watermark-btn:hover {
  background-color: #218838;
  transform: scale(1.02);
}

.organization-downloads button.watermark-btn:active {
  background-color: #1e7e34;
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/CsvDownload/CSVDownloadPage.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,wCAAwC;IACxC,gBAAgB;IAChB,YAAY;AAChB;;EAEE,gCAAgC;EAChC;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,qDAAqD;EACvD;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;;AAGF,yCAAyC;AACzC;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,yDAAyD;AAC7D;;AAEA;;IAEI,sCAAsC;IACtC,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,sDAAsD;AAC1D;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,QAAQ;QACR,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA,oCAAoC;IACpC;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,aAAa;QACb,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2DAA2D;AAC7D;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":[":root {\r\n    --primary-color: #007bff;\r\n    --secondary-color: #f8f9fa;\r\n    --text-color: #333;\r\n    --status-open: #007bff;\r\n    --status-closed: #28a745;\r\n    --status-not-delivered: #dc3545;\r\n    --status-pending: #ffc107;\r\n}\r\n\r\n.csvdownliad-dispatcher-container {\r\n    display: flex;\r\n    height: 100vh;\r\n    background-color: var(--secondary-color);\r\n    overflow: hidden;\r\n    z-index: 100;\r\n}\r\n\r\n  /* Боковая панель с маршрутами */\r\n  .csvdownliad-sidebar {\r\n    width: 350px;\r\n    background: white;\r\n    padding: 20px;\r\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.csvdownliad-1);\r\n  }\r\n  \r\n  .csvdownliad-sidebar h2 {\r\n    font-size: 20px;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n  }\r\n  \r\n\r\n/* Контейнер для маршрутов с прокруткой */\r\n.csvdownliad-routes-list {\r\n    flex-grow: 1;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.csvdownliad-routes-list::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.csvdownliad-routes-list::-webkit-scrollbar-thumb {\r\n    background-color: rgba(0, 0, 0, 0.csvdownliad-2);\r\n    border-radius: 3px;\r\n}\r\n\r\n.csvdownliad-routes-list li {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #ddd;\r\n    transition: background-color 0.csvdownliad-2s ease-in-out;\r\n}\r\n\r\n.csvdownliad-routes-list li:hover,\r\n.csvdownliad-routes-list .csvdownliad-active {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n}\r\n\r\n/* Основная часть с деталями маршрута */\r\n.csvdownliad-route-details {\r\n    flex: 1;\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.csvdownliad-route-details h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* Таблица квитанций */\r\n.csvdownliad-receipts-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 10px;\r\n    background: white;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.csvdownliad-05);\r\n}\r\n\r\n.csvdownliad-receipts-table th,\r\n.csvdownliad-receipts-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.csvdownliad-receipts-table th {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    cursor: pointer;\r\n    transition: background 0.csvdownliad-2s ease-in-out;\r\n}\r\n\r\n.csvdownliad-receipts-table th:hover {\r\n    background: #0056b3;\r\n}\r\n\r\n/* Статусы */\r\n.csvdownliad-status {\r\n    font-weight: bold;\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n    color: white;\r\n    display: inline-block;\r\n    min-width: 100px;\r\n}\r\n\r\n.csvdownliad-status.csvdownliad-Открыта {\r\n    background-color: blue;\r\n}\r\n\r\n.csvdownliad-status.csvdownliad-закрыта {\r\n    background-color: green;\r\n}\r\n\r\n.csvdownliad-status.csvdownliad-не-доставлено {\r\n    background-color: red;\r\n}\r\n\r\n.csvdownliad-status.csvdownliad-в-обработке {\r\n    background-color: var(--status-pending);\r\n    color: black;\r\n}\r\n\r\n/* Заглушка, если маршрут не выбран */\r\n.csvdownliad-placeholder-text {\r\n    font-size: 16px;\r\n    color: #888;\r\n    text-align: center;\r\n    margin-top: 50px;\r\n}\r\n\r\n/* Настройки колонок */\r\n.csvdownliad-sidebar label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    padding: 5px;\r\n}\r\n\r\n.csvdownliad-sidebar label input {\r\n    margin-right: 5px;\r\n}\r\n\r\n/* Мобильная адаптация */\r\n@media (max-width: 768px) {\r\n    .csvdownliad-dispatcher-container {\r\n        flex-direction: column;\r\n        height: auto;\r\n    }\r\n\r\n    .csvdownliad-sidebar {\r\n        width: 95%;\r\n        box-shadow: none;\r\n        padding: 10px;\r\n        background: #fff;\r\n    }\r\n\r\n    .csvdownliad-routes-list {\r\n        display: flex;\r\n        overflow-x: auto;\r\n        gap: 5px;\r\n        white-space: nowrap;\r\n        padding: 10px 0;\r\n    }\r\n\r\n    .csvdownliad-routes-list li {\r\n        display: inline-block;\r\n        padding: 10px;\r\n        font-size: 14px;\r\n        border-radius: 5px;\r\n        background: #f1f1f1;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .csvdownliad-route-details {\r\n        padding: 15px;\r\n    }\r\n\r\n    /* Адаптация таблицы под мобильные */\r\n    .csvdownliad-receipts-table {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n    }\r\n\r\n    .csvdownliad-receipts-table thead {\r\n        display: none;\r\n    }\r\n\r\n    .csvdownliad-receipts-table tbody {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n\r\n    .csvdownliad-receipts-table tr {\r\n        display: flex;\r\n        flex-direction: column;\r\n        padding: 10px;\r\n        background: white;\r\n        border: 1px solid #ddd;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .csvdownliad-receipts-table td {\r\n        border: none;\r\n        text-align: left;\r\n        padding: 5px 0;\r\n    }\r\n\r\n    .csvdownliad-receipts-table td:first-child {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.csvdownliad-date-filter-row {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.csvdownliad-date-filter-row label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.csvdownliad-date-filter-row input[type=\"date\"] {\r\n  padding: 2px 4px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n\r\n/* Базовый стиль кнопок в блоке organization-downloads */\r\n.organization-downloads button {\r\n  color: #fff;\r\n  border: none;\r\n  padding: 10px 15px;\r\n  margin: 5px 5px 5px 0;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.2s ease;\r\n}\r\n\r\n/* Обычный CSV — синий */\r\n.organization-downloads button.csv-btn {\r\n  background-color: #007bff;\r\n}\r\n\r\n.organization-downloads button.csv-btn:hover {\r\n  background-color: #0056b3;\r\n  transform: scale(1.02);\r\n}\r\n\r\n.organization-downloads button.csv-btn:active {\r\n  background-color: #004085;\r\n  transform: scale(0.98);\r\n}\r\n\r\n/* Watermark CSV — зелёный */\r\n.organization-downloads button.watermark-btn {\r\n  background-color: #28a745;\r\n}\r\n\r\n.organization-downloads button.watermark-btn:hover {\r\n  background-color: #218838;\r\n  transform: scale(1.02);\r\n}\r\n\r\n.organization-downloads button.watermark-btn:active {\r\n  background-color: #1e7e34;\r\n  transform: scale(0.98);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
